import { QueryFunctionContext } from 'react-query';
import { API } from '../api';

export function getKnockouts({ signal }: QueryFunctionContext) {
    return API.get(API.PATH.getKnockouts, { signal }).then((res) => res.data);
}

export function getKnockoutDetail({ signal, queryKey }: QueryFunctionContext) {
    const [, leagueId] = queryKey as string[];
    return API.get(API.PATH.getKnockoutDetail(leagueId), { signal }).then((res) => res.data);
}
